
import CONQUER from "../CONQUER";
import LOG, { log } from "../../UTIL/LOG";
import Score from "./SCORE/Score";
import Coins from "./SCORE/Coins";
import Scoreboard from "./SCORE/Scoreboard";
import Lives from "./LIVES/Lives";
import Turns from "./TURNS/Turns";
import Shop from "./SHOP/Shop";
import GameWallet from "./WALLET/GameWallet";
import PlayerInventory from "./INVENTORY/PlayerInventory";
import DailyRewards from "./DAILYREWARD/DailyRewards";
import GameData from "./GAMEDATA/GameData";
import GameAnalytics from "./GAMEDATA/GameAnalytics";
import Signal from "../SIGNAL/Signal";
import RoomInstance from "../ROOMS/RoomInstance/RoomInstance";
import Missions from "./MISSIONS/Missions";

import Messages from "./MESSAGES/Messages";

import Quest from "./QUEST/Quest";
import Rivals from "./RIVALS/Rivals";
import Players from "./PLAYERS/Players";
import UserXP from "./USERXP/UserXP";
import ARRAY from "../../UTIL/ARRAY";
import TimerInstance from "../../UTIL/Instances/TimerInstance";
import DATE from "../../UTIL/DATE";
import { ACTIONS } from "../../Models/ENUM";

class GameInstance
{
    public conquer          : CONQUER;
    public gameID           : any;
    public gameKey          : any;
    public Score            : Score
    public Coins            : Coins;
    public Turns            : Turns;
    public Shop             : Shop;
    public Wallet           : GameWallet;
    public Inventory        : PlayerInventory;
    public DailyRewards     : DailyRewards;
    public Data             : GameData;
    public Analytics        : GameAnalytics
    public Signal           : Signal;
    public Room             : RoomInstance;
    public Missions         : Missions;
    public UserXP           : UserXP;
    public Quest            : Quest;
    public Rivals           : Rivals
    public Scoreboard       : Scoreboard;
    public Lives            : Lives;
    public Messages         : Messages;

    public CONFIG           : any = { MULTIPLAYER:{}, SCORING:{}, TIME:{}, LIVES:{value:1, max:1}, DEBUG:{} };

    public isActive         : boolean = false;

    private Timer           : TimerInstance;

    public isPaused         : boolean = false;

    private usedRevive      : boolean = false;
    private usedExtraTime   : boolean = false;
    private startTime       : number = 0;

    public Players          : Players;
    private isAlive         : boolean = false;
    private isStarted       : boolean = false;
    private didStart        : boolean = false;
 
    constructor( conquer:CONQUER, gameKey:string )
    {
        this.conquer        = conquer;
        this.gameKey        = gameKey;

        this.Score          = new Score( this );
        this.Scoreboard     = new Scoreboard( this );
        this.Coins          = new Coins( this );
        this.Turns          = new Turns( this );
        this.Lives          = new Lives( this );

        this.Shop           = new Shop( this );
        this.Wallet         = new GameWallet( this );
        this.Inventory      = new PlayerInventory( this );

        this.DailyRewards   = new DailyRewards( this );
        this.Data           = new GameData( this );
        this.Analytics      = new GameAnalytics( this );
        this.Signal         = new Signal();
        this.Missions       = new Missions( this );
        this.Rivals         = new Rivals( this );
        this.Players        = new Players( this );
 
        this.Room           = new RoomInstance( conquer, { gameKey:this.gameKey } );
        this.UserXP         = new UserXP( this );
        this.Quest          = new Quest( this );

        this.Messages       = new Messages( this );

        this.Timer          = new TimerInstance({ id:"GAMETIMER", sound:"Alarm", autoStart:false, onSecond:true, Signal:this.Signal } );
    };

    public loadConfig( vars:any )
    {
        ARRAY.extract( vars, this.CONFIG );

        this.Lives.setConfig( this.CONFIG.LIVES );
    }

    public async init() : Promise<any>
    {
        let vars = await this.conquer.do( ACTIONS.GAME_GETONE, { gameKey:this.gameKey });
 
        this.gameID         = vars.game._id;

        //log("GOT GAME", this.gameID );
 
        this.Rivals.init();
        this.Data.init( vars.data );
        this.Shop.init( vars.shop );
        this.Wallet.init( vars.wallet );
        this.Scoreboard.init();
        this.Missions.init( vars.missions );

        this.Messages.init();
  
        this.Inventory.get( true );
        this.Quest.get();
        this.UserXP.get();

        //log("==GAME:onInit");

        this.Signal.set("GAME:onInit");
    }

    /*==========================






    GAME 






    ===========================*/

    public play()
    {
        //log("==GAME: Play");
        this.reset();

        this.isActive = true;
        this.isAlive = true;
 
        if( this.CONFIG.MULTIPLAYER.maxPlayers === 2 ) this.Rivals.getRival();

        this.Analytics.onPlay( this.Score.permanentMultiplier > 1 );
 
        this.Signal.set( "GAME:onPlay" );
    }

    public ready()
    {
        //log("==GAME: Ready");
        this.Analytics.onGameReady();

        this.Signal.set( "GAME:onReady" );
    }

    public start()
    {
        //log("==GAME: Start", this.isStarted );

        if( this.isStarted ) return;
        this.isStarted = true;

        this.didStart = false;

        let self : GameInstance = this;

        this.Signal.set( "GAME:onReveal" );

        if( !this.CONFIG.TIME.countDown ) return this.doStart();
        
        this.Signal.set( "GAME:onStartCountDown" );
        this.Timer.start({ seconds:3, onTimeUp:function(){ self.doStart() } } );
    }

    private doStart()
    {
        //log("==GAME: Do Start", this.didStart );

        if( this.didStart ) return;
        this.didStart = true;

        this.Analytics.onGameStart();
 
        this.Signal.set( "GAME:onStart" );
        
        this.startTime = DATE.now();

        this.startTimer( this.CONFIG.TIME.duration );
    }

    private startTimer( seconds?:number )
    {
        //log("== startTimer", seconds );

        if( !seconds ) return;

        let self = this;

        this.Timer.start({ seconds:seconds, onTimeUp:function(){ self.timeUp() }} )
    }
 
    public pause()
    {
        this.Signal.set( "GAME:onPause" );

        if( this.CONFIG.globalPause ) return;

        this.Timer.pause();

        this.isPaused = true;
    }

    public resume()
    {
        if( !this.isAlive ) return;

        this.Timer.resume();

        this.isPaused = false;
        this.Signal.set( "GAME:onResume" );
    }

    public kill()
    {
        if( this.CONFIG.DEBUG.invulnerable || !this.isAlive  ) return;
        this.Lives.set(0);
        this.die();
    }

    public die()
    { 
        if( this.CONFIG.DEBUG.invulnerable || !this.isAlive  ) return;
        
        //log("==GAME: Die", this.isAlive );
   
        let lives = this.Lives.decrease();

        if( lives>0 ) return;

        this.isAlive = false;
        
        this.Analytics.onDie();
 
        if( !this.CONFIG.LIVES.revive || this.usedRevive ) return this.end(); //|| this.conquer.Ads.loadedNetwork != 'None'

        this.conquer.Haptic.long();

        this.pause();
        this.Signal.set( "GAME:onDie" );
    }

    public timeUp()
    {
        //log("GAME:time up!");
        if( this.CONFIG.DEBUG.invulnerable ) return;

        this.isAlive = false;

        //log("==GAME:TimeUp", this.CONFIG.TIME.extraTime, this.usedExtraTime );
        if( !this.CONFIG.TIME.extraTime || this.usedExtraTime ) return this.end();  //|| this.conquer.Ads.loadedNetwork != 'None'
 
        this.conquer.Haptic.long();

        this.pause();

        this.Analytics.onTimeUp();
        //log("BEFORE ONTIMEUP EVENT");

        this.Signal.set( "GAME:onTimeUp" );
    }

    public onExtraTime( boolean:boolean, extraTime?:number )
    {   
        extraTime = extraTime || this.CONFIG.TIME.extraTime;
        //log("== ON EXTRA TIME", boolean, extraTime );
        if( !boolean ) return this.end();

        this.startTimer( extraTime );

        this.usedExtraTime = true;
        this.onContinue();
    }

    public onRevive( boolean:boolean )
    {
        //log("==GAME onRevive", boolean );

        if( !boolean ) return this.end();

        this.Lives.reset();
        
        this.usedRevive = true;
        this.onContinue();
    }

    private onContinue()
    {
        //log("==GAME onContinue" );
        this.isAlive = true;
        this.Analytics.onContinue();
        this.Signal.set( "GAME:onContinue" );
        this.resume();
    }

    public end()
    {
        //log("== GAME END!");
        this.isAlive = false;
        this.Data.increaseTotal( "GamesPlayed" );
   
        this.Timer.stop();
        this.UserXP.increase();
        this.conquer.Haptic.long();

        this.Analytics.onGameOver( DATE.now() - this.startTime );
 
        //log("GAME END! Before event");

        this.Signal.set( "GAME:onEnd" );
    }

    public over()
    {
        //log("Game over, Score to coins", this.CONFIG.SCORING.scoreToCoins );

        this.Signal.set("PlayGames");
        this.Score.toCoins( this.CONFIG.SCORING.scoreToCoins );
        this.Score.save();

        this.Signal.set( "GAME:onOver" );
    }

    public reset()
    {
        this.Timer.stop();

        this.Score.reset();
        this.Coins.reset();
        this.Lives.reset();

        this.usedRevive     = false;
        this.usedExtraTime  = false;
        this.isPaused       = false;
        this.isStarted      = false;
        this.isActive       = false;
        this.isStarted      = false;
        this.didStart       = false;
        this.isAlive        = true;
    }

    public exit()
    {
        if( !this.isActive ) return;

        //log("GAME:onExit");
 
        this.isActive       = false;
 
        this.Analytics.onGameExit();

        this.Score.setPermanentMultiplier();
        this.Coins.setPermanentMultiplier();
        
        this.Timer.stop();

        this.Signal.set( "GAME:onExit" );
    }

}

export default GameInstance;